import React, { useState, useEffect, useRef, useMemo } from 'react';
import { ShoppingCart, Plus, Package, Users, LayoutGrid, Trash2, X, Search, Camera, Receipt, Save,
  Minus, Image as ImageIcon, BarChart3, Settings, Printer, Clock, ArrowUpRight, Edit3,
  FileText, Download, AlertTriangle, Ban, UserCheck, Share2, Copy, AlertOctagon, RefreshCw, Truck,
  RotateCcw, ChevronLeft, ChevronRight, ScanBarcode, UserCircle2, Layers, Lock, LogIn, Menu, LogOut,
  HelpCircle, CheckSquare, Square, MapPin, Phone, PauseCircle, PlayCircle, AlertCircle, Banknote,
  CreditCard, Smartphone, BookOpen, Crown, Unlock, Globe, Wallet, History, FileCheck, Boxes, PenLine,
  CreditCard as CardIcon, Store, ArrowRightLeft, UserCog, Briefcase, FileOutput, Megaphone, UserPlus,
  Link, MonitorSmartphone, Contact, FileMinus } from 'lucide-react';
import { apiCall, generateId, formatPrice, formatDate, compressImage,
  base64ToFile, printHtmlDiv, printRawHtml, printBarcodeDiv } from '../utils/utils.js';

const QuickReturnModal = ({ product, onClose, onProcessReturn, getProductPrice }) => {
    const [qty, setQty] = useState(1);
    const [variantName, setVariantName] = useState('');
    const [returnType, setReturnType] = useState('Restock'); // Restock or Damage
    const [refundAmount, setRefundAmount] = useState(getProductPrice(product));

    useEffect(() => {
        setRefundAmount(getProductPrice(product) * qty);
    }, [qty, product, getProductPrice]);

    return (
        <div className="fixed inset-0 bg-[#1a1a1a]/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white w-full max-w-sm rounded-xl shadow-lg border border-[#e1e3e5] overflow-hidden flex flex-col">
                <div className="p-4 border-b border-[#e1e3e5] flex justify-between items-center bg-[#e3d0ff]">
                    <h3 className="font-bold text-[#50248f] flex items-center gap-2"><RotateCcw size={18}/> Quick Scanner Return</h3>
                    <button onClick={onClose} className="text-[#5c5f62] hover:text-[#1a1a1a]"><X size={20}/></button>
                </div>
                <form onSubmit={(e) => { e.preventDefault(); onProcessReturn(product, variantName, parseInt(qty), returnType, parseFloat(refundAmount)); }} className="p-4 flex-1">
                    <div className="mb-4">
                        <p className="font-bold text-[#1a1a1a] text-sm">{product.name}</p>
                        <p className="text-xs text-[#008060] mt-1 font-semibold">Unit Price: {formatPrice(getProductPrice(product))}</p>
                    </div>
                    {product.hasVariants && (
                        <div className="mb-4">
                            <label className="text-xs font-semibold text-[#5c5f62] uppercase block mb-1">Variant Returning</label>
                            <select required value={variantName} onChange={e=>setVariantName(e.target.value)} className="w-full p-2 border border-[#c9cccf] rounded-lg text-sm bg-white outline-none">
                                <option value="">Select Option...</option>
                                {product.variants.map((v, i) => <option key={i} value={v.name}>{v.name}</option>)}
                            </select>
                        </div>
                    )}
                    <div className="grid grid-cols-2 gap-3 mb-4">
                        <div>
                            <label className="text-xs font-semibold text-[#5c5f62] uppercase block mb-1">Return Qty</label>
                            <input required type="number" min="1" value={qty} onChange={e=>setQty(parseInt(e.target.value)||'')} className="w-full p-2 border border-[#c9cccf] rounded-lg text-sm outline-none" />
                        </div>
                        <div>
                            <label className="text-xs font-semibold text-[#5c5f62] uppercase block mb-1">Refund Amount</label>
                            <input required type="number" value={refundAmount} onChange={e=>setRefundAmount(e.target.value)} className="w-full p-2 border border-[#c9cccf] rounded-lg text-sm outline-none font-bold text-[#d82c0d]" />
                        </div>
                    </div>
                    
                    <div className="mb-6">
                        <label className="text-xs font-semibold text-[#5c5f62] uppercase block mb-2">Item Condition</label>
                        <div className="grid grid-cols-2 gap-3">
                            <label className={`flex flex-col items-center p-3 border rounded-lg cursor-pointer transition-colors ${returnType === 'Restock' ? 'border-[#008060] bg-[#e4fcf4] text-[#008060]' : 'border-[#c9cccf] bg-white text-[#5c5f62] hover:bg-[#f6f7f8]'}`}>
                                <input type="radio" className="hidden" checked={returnType === 'Restock'} onChange={() => setReturnType('Restock')} />
                                <Package size={20} className="mb-1"/>
                                <span className="font-semibold text-xs">Perfect (Restock)</span>
                            </label>
                            <label className={`flex flex-col items-center p-3 border rounded-lg cursor-pointer transition-colors ${returnType === 'Damage' ? 'border-[#d82c0d] bg-[#fbeae5] text-[#d82c0d]' : 'border-[#c9cccf] bg-white text-[#5c5f62] hover:bg-[#f6f7f8]'}`}>
                                <input type="radio" className="hidden" checked={returnType === 'Damage'} onChange={() => setReturnType('Damage')} />
                                <AlertTriangle size={20} className="mb-1"/>
                                <span className="font-semibold text-xs">Damaged (Loss)</span>
                            </label>
                        </div>
                    </div>

                    <button type="submit" disabled={!qty || (product.hasVariants && !variantName)} className="w-full bg-[#50248f] text-white py-2.5 rounded-lg font-semibold shadow-sm hover:bg-[#3e1b73] transition-colors disabled:opacity-50">Log Refund & Return</button>
                </form>
            </div>
        </div>
    );
};

export default QuickReturnModal;
